import React from "react";

const LAOGlobalContext = React.createContext({});

export const useLAOGlobalContext = () => React.useContext(LAOGlobalContext);

export default LAOGlobalContext;